import React from 'react';
import { useSelector } from 'react-redux';
import BangloreImage from '../../assets/images/bangalore.webp';
import ChennaiImage from '../../assets/images/chennai.webp';
import HyderabadImage from '../../assets/images/hyderabad.webp';
import KolkataImage from '../../assets/images/kolkata.webp';
import MumbaiImage from '../../assets/images/mumbai.webp';
import PuneImage from '../../assets/images/pune.webp';
import DelhiImage from '../../assets/images/delhi-mobile.webp';
import ChandigarhImage from '../../assets/images/chandigarh.webp';
import GurugramImage from '../../assets/images/gurugram.webp';
import NoidaImage from '../../assets/images/noida.webp';
import IndoreImage from '../../assets/images/indore.webp';

const linksData = [
  {
    src: DelhiImage,
    alt: 'stashfin-delhi',
    text: 'Personal Loan in Delhi',
    href: './delhi',
    cityName: 'delhi',
  },
  {
    src: ChennaiImage,
    alt: 'stashfin-chennai',
    text: 'Personal Loan in Chennai',
    href: './chennai',
    cityName: 'chennai',
  },
  {
    src: MumbaiImage,
    alt: 'stashfin-mumbai',
    text: 'Personal Loan in Mumbai',
    href: './mumbai',
    cityName: 'mumbai',
  },
  {
    src: HyderabadImage,
    alt: 'stashfin-hyderabad',
    text: 'Personal Loan in Hyderabad',
    href: './hyderabad',
    cityName: 'hyderabad',
  },
  {
    src: PuneImage,
    alt: 'stashfin-pune',
    text: 'Personal Loan in Pune',
    href: './pune',
    cityName: 'pune',
  },
  {
    src: BangloreImage,
    alt: 'stashfin-bangaluru',
    text: 'Personal Loan in Bangaluru',
    href: './bangalore',
    cityName: 'bangalore',
  },
  {
    src: KolkataImage,
    alt: 'stashfin-kolkata',
    text: 'Personal Loan in Kolkata',
    href: './kolkata',
    cityName: 'kolkata',
  },
  {
    src: ChandigarhImage,
    alt: 'stashfin-chandigarh',
    text: 'Personal Loan in Chandigrah',
    href: './chandigarh',
    cityName: 'chandigarh',
  },
  {
    src: GurugramImage,
    alt: 'stashfin-gurugram',
    text: 'Personal Loan in Gurugram',
    href: './gurugram',
    cityName: 'gurugram',
  },
  {
    src: NoidaImage,
    alt: 'stashfin-noida',
    text: 'Personal Loan in Noida',
    href: './noida',
    cityName: 'noida',
  },
  {
    src: IndoreImage,
    alt: 'stashfin-indore',
    text: 'Personal Loan in Indore',
    href: './indore',
    cityName: 'indore',
  },
];

const RelatedLinks = () => {
  const { cityData } = useSelector((state) => state.CityWiseIplReducer);
  const newLinksData = linksData.filter((link) => link?.cityName !== cityData?.city_route);

  const handleRedirect = (link) => {
    window.location.href = link;
  };

  return (
    <section id="relatedLinks" className="related-links">
      <div className="heading">Related Links</div>
      <div className="links-container">
        <div className="col-1">
          {newLinksData?.slice(0, 4).map((link) => (
            <div className="image-box" key={link.alt} onClick={() => handleRedirect(link.href)}>
              <img src={link.src} alt={link.alt} loading="lazy" />
              <p>{link.text}</p>
            </div>
          ))}
        </div>
        <div className="col-2">
          {newLinksData?.slice(4, 7).map((link) => (
            <div className="image-box" key={link.alt} onClick={() => handleRedirect(link.href)}>
              <img src={link.src} alt={link.alt} loading="lazy" />
              <p>{link.text}</p>
            </div>
          ))}
        </div>
        <div className="col-3">
          {newLinksData?.slice(7, 10).map((link) => (
            <div className="image-box" key={link.alt} onClick={() => handleRedirect(link.href)}>
              <img src={link.src} alt={link.alt} loading="lazy" />
              <p>{link.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedLinks;
